<template>
  <div class="wrapper" :class="{'browser-wrapper': !isIos}" :style="iosOrAndroidStyle" v-show="loadingPageOver">
    <w-navbar v-show="iosOrAndroidShow" :icon="'iconchevron-left'" :nav_title="sectionTitle"
              @mobileLeftBtn="backToEditor" :right_btn_html="rightBtnHtml" @mobileRightBtn="complete"/>
    <div v-if="!loadingShow || loadingOver">
			<!-- {{formData}} -->
			<w-cv-form :formList="formList" :req="formData" :section-type="moduleType" :company-not-click="is_now_sub">
				<div :slot="`suggest-${suggestField}`" v-if="suggest">
					<suggest-card @handleClose="changeSuggestState"/>
				</div>
			</w-cv-form>
			<div class="module-edit" @click="toEditContent" v-if="moduleType !== 'opus'">
				<div class="title">
					<span>{{liveInfo.title}}</span>
				</div>
				<div class="flex-between">
					<div class="content" :class="{'no-content': formData && !formData.description}"
							v-html="formData && formData.description || liveInfo.description"></div>
					<span class="iconfont iconchevron-right"/>
				</div>
			</div>
			<div class="more-operate flex-start footer">
				<div class="flex-center delete" @click="deleteInfoConfirm" v-if="deleteState">
					<span class="iconfont iconshanchu"></span>
					<span>删除</span>
				</div>
				<div class="flex-center experience" v-if="experienceData.length && moduleType !== 'opus'">
					<w-tooltip v-if="experienceTooltipShow" class="w-tooltip" @handleClose="closeToolTip"></w-tooltip>
					<span class="iconfont iconbox"></span>
					<span @click="changeExperienceState">经历库</span>
				</div>
				<div class="flex-center tips" @click="changeTipsStatus" v-if="moduleType !== 'opus'">
					<span class="iconfont iconwenhao"></span>
					<span>小贴士</span>
				</div>
			</div>
    </div>
		<div :class="['add-exp-btn', isWorkHasFormData ? 'add-exp-btn-active' : '']" v-show="!loadingShow && isWorkModule" @click="handleClickAddExp">
			<i class="iconfont iconcvs-chuangjian"></i><span>再写一段同公司经历</span>
		</div>
    <cv-tips :state="cvTipShow" @handleClose="changeTipsStatus"/>
    <experience-dialog v-if="loadingOver" :state="experienceState" :radio="true" :experience-data="experienceData"
                       ref="experienceDialog"
                       :title="sectionTitle" @selectExperience="selectExperience" @deleteExperience="deleteExperience"
                       @handleClose="changeExperienceState"></experience-dialog>
    <w-loading v-if="loadingShow"/>
  </div>
</template>

<script>
	import WNavbar from '@/components/global/w-navbar'
	import WCvForm from '@/components/cv/w-cv-form'
	import WLoading from '@/components/global/w-loading'
	import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
	import { moduleMixin } from '../../../assets/js/mixin/cv'
	import { componentsMixin } from '../../../assets/js/mixin/components'
	import { envMixin, eventMixin } from '../../../assets/js/mixin/global'
	import { userMixin } from '../../../assets/js/mixin/user'
	import { deleteRedundancy, setupWebViewJavascriptBridge, dealDateFormat } from '../../../assets/js/utils'
	import experienceDialog from '@/views/cv-experience/experience-dialog'
	import api from '@/api/api-list'

	let moment = require('moment')

	let { orgsForm } = require('@/assets/json/cv')
	let { edusForm } = require('@/assets/json/cv')
	let { worksForm } = require('@/assets/json/cv')
	let { opusForm } = require('@/assets/json/cv')
	let { degreeOptions } = require('@/assets/json/cv')

	export default {
		name: 'editIndex',
		mixins: [ moduleMixin, componentsMixin, envMixin, eventMixin, userMixin ],
		props: {
			addSave: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				orgsForm,
				edusForm,
				worksForm,
				opusForm,
				toPath: '',
				experienceState: false, // 经历库弹窗状态
				experienceData: [], // 经历库的数据
				formData: {}, // 页面上的数据
				fromName: '',
				is_sub_item: false,//是否进入第二段经历编写
				is_now_sub: false,//当时是不是再进行第二段经历编写
				info_id: null,//
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.fromName = from.name || ''
			})
		},
		mounted () {
			setTimeout(() => {
				this._initModuleInfos()
			}, 30)
		},
		computed: {
			...mapState('cv', [ 'orgs', 'works', 'edus', 'cv', 'opus', 'isFirstCvInfo', 'isSubItemInfoIds' ]),
			...mapState('cvExperience', {
				orgsExperience: 'orgs',
				worksExperience: 'works',
				edusExperience: 'edus',
				opusExperience: 'opus',
			}),
			...mapGetters('cvExperience', [ 'currentExperience' ]),
			// 表单的内容
			formList () {
				let { type } = this.$route.params
				return this[`${ type }Form`]
			},
			// 删除按钮的显示逻辑
			deleteState () {
				let { type, info_id } = this.$route.params
				return info_id !== 'add'
			},
			// 通过type 判断 text-editor 的 title 和 默认 description
			liveInfo () {
				switch (this.moduleType) {
					case 'edus':
						return {
							title: '在校经历',
							description: '可以列出成绩、荣誉奖项、相关课程等'
						}
						break
					case 'orgs':
						return {
							title: '经历描述',
							description: '介绍在什么活动中自己负责的内容，列出通过什么动作获得了什么成果'
						}
						break
					case 'works':
						return {
							title: '工作描述',
							description: '简短介绍公司与自己负责的任务，分条罗列在什么项目中，通过某些动作或技能达到可量化的结果'
						}
						break
				}
			},
			isWorkModule(){
				return this.moduleType === 'works'
			},
			isWorkHasFormData(){
				if(this.isWorkModule){
					if(this.formData.company && (this.formData.dept || this.formData.city || this.formData.end_at || this.formData.start_at || this.formData.description|| this.formData.title)){
						return true
					}else {
						return false
					}
				}
				return false
			},
			// 是否是会员
			isMembership(){
				return this.userData?.is_membership
			},
		},
		watch: {},
		components: {
			WNavbar,
			WCvForm,
			WLoading,
			experienceDialog,
		},
		methods: {
			...mapActions('cv', [ 'getModuleInfo', 'updateModuleInfo', 'createModuleInfo', 'createCvDetail','getShowNpsState' ]),
			...mapActions('cvExperience', [ 'getExperience' ]),
			...mapMutations('cvExperience', [ 'changeExperienceField', 'changeExperience' ]),
			...mapMutations('cv', ['changeCurrentInfo', 'setIsSubItemInfoIds']),
			// 点击返回事件
			backToEditor () {
				this.verifyData({ req: this.formData, count: this.count })
			},
			// 跳转内容编辑
			async toEditContent () {
				let { type, info_id, token } = this.$route.params
				this.changeCurrentInfo(this.formData)

				this.$router.push({
					path: `/cvs/${ token }/${ type }/${ info_id }/content_edit`,
					name: 'convention-module-content'
				})
			},
			// 是否有text-editor弹窗
			async complete (textEditor) {
				let confirmBtn = { text: '去完善' }
				let cancelBtn = { text: '忽略' }
				let editorToken = this.$db.ls.get(`${ this.cvAccountToken }-editor`)
				let endAt = this.$db.ls.get(`${ this._token }-end`)
				let { type, info_id, token } = this.$route.params
				// 作品集
				if (type === 'opus') {
					if (!this.formData.qrcode) {
						this.showToast('完善经历信息，更容易获得青睐哦', 2000)
					} else {
						// 非会员
						if(!this.isMembership){
							this.showToast('该功能为会员专享', 1500)
							this.$router.push(`/buy/member/order`)
						}else{
							this.is_sub_item = false
							this._complete()
						}
					}
					return
				}
				if (!this.infoNotEmpty(this.formData) && !textEditor) {
					this.showToast('完善经历信息，更容易获得青睐哦', 2000)
				} else if (this.moduleType === 'edu' && !this.formData.end_at && !this.formData.present && !endAt) {
					this.$createDialog({
						type: 'confirm',
						content: `毕业时间是简历初筛时的关注点，<br>若未毕业请填写预计毕业时间~`,
						confirmBtn,
						cancelBtn,
						onConfirm: () => {
							this.$db.ls.set(`${ this._token }-end`, true)
						},
						onCancel: () => {
							this.$db.ls.set(`${ this._token }-end`, true)
							this.is_sub_item = false
							this._complete()
						}
					}).show()
				} else if (!editorToken && !this.formData.description) {
					this.$createDialog({
						type: 'confirm',
						content: `经历描述是模块的重要内容<br>建议参考填写案例去完善`,
						confirmBtn,
						cancelBtn,
						onConfirm: () => {
							this.toEditContent()
						},
						onCancel: () => {
							this.$db.ls.set(`${ this.cvAccountToken }-editor`, true)
							this.is_sub_item = false
							this._complete()
						}
					}).show()
				} else {
					this.is_sub_item = false
					this._complete()
				}

			},
			// 点击完成
			async _complete (textEditor) {
				try {
					// this.formData.description = this.formData.description ?
					// 	this.formData.description.replace(/(?<= )class=".*?"/gi, '').replace(/<div/gi, '<p').replace(/\/div>/gi, '\/p>') :
					// 	null

					if(this.formData.company && !this.formData.company_id){
						let res = await this.$api.staticApi[`companyComplete`]({
							keyword: this.formData.company
						})
						if(res.code === 1000 && res.data.length > 0){
							this.formData.company_id = res.data[0].id
							this.formData.company_token = res.data[0].token
						}
					}

					if(this.formData.city && !this.formData.city_id){
						let res = await this.$api.staticApi[`cityComplete`]({
							keyword: this.formData.city
						})
						if(res.code === 1000 && res.data.length > 0){
							this.formData.city_id = res.data[0].id
						}
					}

					if(this.formData.title && !this.formData.title_id){
						let res = await this.$api.staticApi[`positionComplete`]({
							keyword: this.formData.title
						})
						if(res.code === 1000 && res.data.length > 0){
							this.formData.title_id = res.data[0].id
						}
					}

					if(this.formData.university && !this.formData.university_id){
						let res = await this.$api.staticApi[`universityComplete`]({
							keyword: this.formData.university
						})
						if(res.code === 1000 && res.data.length > 0){
							this.formData.university_id = res.data[0].id
						}
					}

					if(this.formData.major && !this.formData.major_id){
						let res = await this.$api.staticApi[`majorComplete`]({
							keyword: this.formData.major
						})
						if(res.code === 1000 && res.data.length > 0){
							this.formData.major_id = res.data[0].id
						}
					}
					if(this.formData.uni_school && !this.formData.uni_school_id){
						let res = await this.$api.staticApi[`unischoolComplete`]({
							keyword: this.formData.uni_school
						})
						if(res.code === 1000 && res.data.length > 0){
							this.formData.uni_school_id = res.data[0].id
						}
					}
					let { type, info_id, token } = this.$route.params
					if (this.formData.id && this.formData.kind !== 'sample') {
						let info = this[`${ type }Experience`].filter(item => item.id === this.formData.id)[0]
						if(type === 'opus'){
							if(this.formData.id){
								this.experienceChange('update')
							}else{
								this.experienceChange('create')
							}
						} else if (!this.contrastInitData(this.formData, info)) {
							if (this.formData.id === Number(info_id)) {
								this.$router.back()
							} else {
								// 同步给cv detail
								this._updateCvDetail(this.formData.id)
							}
						}else if (this.contrastInitData(info, this.formData)) {
							if (await this.verifyExperience()) {
								this.$createDialog({
									title: '修改同步提示',
									type: 'confirm',
									content: `此段经历在其他简历中被引用，<br>是否同步修改到其他简历？`,
									confirmBtn: '同步',
									cancelBtn: '不同步',
									onConfirm: () => {
										this.experienceChange('update')
									},
									onCancel: () => {
										this.experienceChange('create')
									}
								}).show()
							} else {
								this.experienceChange('update')
							}
						}else {
							if(this.isWorkModule){
								console.log("type",type)
								if(info_id !== 'add'){
									this.$router.replace(`/cvs/${token}/works/add/edit`)
								}
								this.initSubItemFormData()
							}
						}
					} else {
						this.experienceChange('create')
					}
				} catch (e) {
					console.log(e)
				}
				this.getShowNpsState()
			},
			// 校验当前经历是否被引用
			async verifyExperience () {
				let { type } = this.$route.params
				let { id } = this.formData
				let res = await this.$api.cv[`${ type }Verify`](id)
				if (res.code === 1000) {
					return res.data.imported
				}
			},
			// 更新经历
			async experienceChange (operation) {
				let { type, token } = this.$route.params
				let data = JSON.parse(JSON.stringify(this.formData))
        console.log(data, token, type, "================>lalalalal")
				let payload = {}
				if(type !== 'opus'){
					payload = {
						...deleteRedundancy(data),
						lang: this.cv.basic_info.lang
					}
					if (payload.end_at === '至今' || payload.end_at === 'Present') {
						payload.present = payload.end_at
						payload.end_at = null
					} else if (payload.end_at) {
						payload.present = null
					}
					payload.start_at = payload.start_at ? moment.utc(payload.start_at) : null
					payload.end_at = payload.end_at ? moment.utc(payload.end_at) : null

					if (payload.degree) {
						const degreeData = degreeOptions.find(item => item.cn === payload.degree)
						payload.degree_id = degreeData && degreeData.id
					}

				}else{
					payload = {
						...data,
						lang: this.cv.basic_info.lang
					}
				}
				if(this.is_now_sub){
					let payload1 = {}
					let field = [
								'title_color',
								'font',
								'font_size',
								'line_spacing',
								'page_margin',
								'head_format', 'time_format', 'format_priority', 'body_format', 'punctuation_format' ]
					let format_info = {}
					field.forEach(item => {
						format_info[item] = this.cv.format_info[item]
					})
					format_info.format_priority = 'city'
					format_info.body_format = 'two_line'
					payload1 = {
						operation_type: 'update_format_info',
						format_info
					}

					await this.updateCvDetail({ token, payload: payload1 })
					payload.is_sub_item = true
				}
				if (operation === 'update') {
					let updateResCode = await this.updateModuleInfo({
						id: this.formData.id,
						payload,
						moduleName: type
					})
					if(updateResCode === 600213){
						this.showToast('该功能为会员专享', 1500)
						this.$router.push(`/buy/member/order`)
						return
					}
					this._updateCvDetail(this.formData.id)
				} else {
					let data = await this.createModuleInfo({
						payload,
						type
					})
					if (data === 80143) {
						this.showAlert('每个模块最多添加30段经历<br>请删除多余经历后重试', '我知道了')
					} else if(data === 600213){
						this.showToast('该功能为会员专享', 1500)
						this.$router.push(`/buy/member/order`)
					} else {
						this._updateCvDetail(data[type].id)
					}
				}
			},
			// 更新cv里面的信息
			async _updateCvDetail (id) {
				let { token, type, info_id } = this.$route.params
				let { basic_info: { kind }, submodule_info: { sections_position }, submodule_info, format_info } = this.cv
				let sectionPosition = JSON.parse(JSON.stringify(sections_position))
				sectionPosition.forEach(item => delete item.title)
				// 如果不是添加模块，或者是sample 经历的话就需要替换id
				let replace = info_id !== 'add' || this.formData.kind === 'sample'
				let ids = JSON.parse(JSON.stringify(submodule_info[`${ type }_ids`]))
				// 判断 ids 里面是否有当前编辑的简历， 并且找到其位置
				const index = ids.findIndex(item => item === Number(info_id))
				// 当前模块是否存在于简历排序中
				const moduleIndex = sectionPosition.findIndex(item => item.type === type)
				// 如果存在模块就替换，否则往ids里面push数据
				index !== -1 && replace ? (ids[index] = id) : (()=>{
					if(this.isSubItemInfoIds){
						let beforeIndex = ids.findIndex(item => item === Number(this.isSubItemInfoIds))
						if(beforeIndex > -1){
							ids.splice(beforeIndex + 1, 0, id)
						}
						this.setIsSubItemInfoIds(id)
					}else {
						ids = [ ...ids, id ]
						if(info_id == 'add' && this.isWorkModule){
							this.setIsSubItemInfoIds(id)
						}
					}
				})()
				let payload = {
					operation_type: kind === 'template' || kind === 'sample' ? '' : 'update_submodule_info',
				}
				// 判断如果是简历里面不存在模块，就往数组中塞一条数据
				if (moduleIndex === -1) {
					sectionPosition = [
						...sectionPosition,
						{ type, id: null, info_ids: [] }
					]
				}

				// 处理submodule参数
				payload.submodule_info = {
					...submodule_info,
					[`${ type }_ids`]: ids,
					sections_position: sectionPosition
				}
				// 大牛简历或者模板简历需要创建简历
				if (kind === 'template' || kind === 'sample') {
					payload.basic_info = {
						...this.cv.basic_info,
						source_cv_token: this.cv.basic_info.token || null,
						sample_cv_source_token: this.cv.basic_info.token || null, // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
						kind: null,
						token: null
					}
					payload.format_info = format_info
					let res = await this.createCvDetail(payload)
					if (res.code === 3001) {
						this.showToast(res.message)
						return
					}
				//这里增加判断

					if(this.is_sub_item ){
						if(info_id !== 'add'){
							this.$router.replace(`/cvs/${token}/works/add/edit`)
						}
						this.initSubItemFormData()
					}else {
						this.setIsSubItemInfoIds("")
						this.$fn.redirect(
							`${window.location.origin}/cvs/${ this.cv.basic_info.token }/editor`,
							() => {
								this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
							}
						)
					}
				} else {
					await this.updateCvDetail({ token, payload })
					if(this.is_sub_item ){
						if(info_id !== 'add'){
							this.$router.replace(`/cvs/${token}/works/add/edit`)
						}
						this.initSubItemFormData()
					}else {
						this.$fn.redirect(
							`${window.location.origin}/cvs/${ this.cv.basic_info.token }/editor`,
							() => {
								this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
							}
						)
					}
				}
			},
			// 删除经历库里面的经历
			deleteExperience (item) {
				let { type } = this.$route.params
				this.$createDialog({
					title: '提示',
					type: 'confirm',
					content: `删除无法还原,确定删除?`,
					onConfirm: async () => {
						try {
							let apiMethod = ''
							if(type === 'orgs'){
								apiMethod = 'deleteOrgs'
							}else if(type === 'works'){
								apiMethod = 'deleteWorks'
							}else if(type === 'opus'){
								apiMethod = 'deleteOpus'
							}else {
								apiMethod = 'deleteEdus'
							}
							// let apiMethod = type === 'orgs' ? 'deleteOrgs' : type === 'works' ? 'deleteWorks' : 'deleteEdus'
							let res = await this.$api.cv[apiMethod](item.id)
							if (res.code === 1000) {
								this.experienceData = this.experienceData.filter(val => val.id !== item.id)
								if (!this.experienceData.length) this.changeExperienceState()
							} else {
								this.$createDialog({
									type: 'alert',
									content: '该段经历在其他简历被使用，无法删除',
									confirmBtn: '我知道了',
								}).show()
							}
						} catch (e) {
							console.log(e)
						}
					}
				}).show()
			},
			// 删除经历
			deleteInfoConfirm () {
				let { submodule_info } = this.cv
        let { sections_position } = submodule_info;
				let { token, info_id, type } = this.$route.params
				let ids = submodule_info[`${ type }_ids`]
				let payload = {};
        let title = null;
				let content = null;
				// 只剩一条经历，直接删除模块
				if(ids.length !== 1){
					payload = {
            operation_type: 'update_submodule_info',
            submodule_info: {
              [`${ type }_ids`]: ids.filter(i => i !== Number(info_id))
            }
				  }
          title = '提示';
          content = '删除无法还原,确定删除?'
				}else {
          payload = {
            operation_type: 'update_submodule_info',
            submodule_info: {
              [`${ type }_ids`]: [],
              sections_position: sections_position.filter(item => item.type != type)
            }
				  }
          title = '提示';
          content = '删除内容将无法还原\n确定要删除当前模块吗？'
        }

				this.$createDialog({
					title,
					type: 'confirm',
					content,
					onConfirm: async () => {
						try {
							if(type === 'opus'){
								//走直接作品接口
								await api.cv.deleteOpus(info_id);
							}
							await this.updateCvDetail({ token, payload })
							this.$router.back()
						} catch (e) {
							console.log(e)
						}
					}
				}).show()
			},
			// 初始化
			async _initModuleInfos () {
				try {
					let { info_id, type } = this.$route.params
					let { lang } = this.cv.basic_info
					this.getExperienceInfo(info_id, type, lang)
					// 获取经历库数据
					let apiMethod = ''
					if(type === 'edus'){
						apiMethod = 'getEduExperience'
					}else if(type === 'works'){
						apiMethod = 'getWorkExperience'
					}else if(type === 'opus'){
						apiMethod = 'getOpuExperience'
					}else{
						apiMethod = 'getOrgExperience'
					}
					// let apiMethod = type === 'edus' ? 'getEduExperience' : type === 'works' ? 'getWorkExperience' : 'getOrgExperience'
					await this.getExperience({ template: [], payload: { lang }, moduleName: type, apiMethod })
					// 过滤掉当前简历里面的选择的经历数据
					this.experienceData = this[`${ type }Experience`].filter(item => {
						if (!this.cv.submodule_info[`${ type }_ids`].includes(item.id) || item.id === info_id - 0) {
							item.checked = item.id === info_id - 0
							return item
						}
					})
					this.changeExperienceField(type)
					if(this.isFirstCvInfo.isFirst && type === 'edus'){
					  console.log("this.isFirstCvInfo.data.graduate_at",this.isFirstCvInfo.data.graduate_at)
					  this.formData.university = this.isFirstCvInfo.data.cust_uni_name || ''
					  this.formData.degree = this.isFirstCvInfo.data.cust_degree || ''
					  this.formData.edu_type = this.isFirstCvInfo.data.edu_type || ''
					  this.formData.end_at = this.isFirstCvInfo.data.graduate_at ? moment(this.isFirstCvInfo.data.graduate_at).format("YYYY-MM") : this.isFirstCvInfo.data.graduate_at
					}
					if(info_id === 'add' && type === 'edus'){
						this.formData.show_tags = this.formData.show_tags || []
					}
					this.loadingShow = false
					this.loadingOver = true
				} catch (e) {
					console.log(e)
				}
			},
			// ios 相关内容
			iosBridge () {
				if (this.isIos) {
					let url = `${ process.env.VUE_APP_HOST }/cvs/${ this._token }/editor`
					this.registerBridge('iosReturnCvEditor', this.verifyData, { req: this.formData, count: this.count }, { url })
					this.registerBridge('saveModule', this._complete, false, { url })
					this.registerBridge('loadPageTitle', null, null, { name: this.sectionTitle })
				}
			},
			//再添加一段经历
			handleClickAddExp(){
				if(!this.isWorkHasFormData){
					if(!this.formData.company){
						this.showToast('请先填公司名称', 1500);
					}else {
						this.showToast('至少填写两个信息', 1500);
					}

					return
				}
				this.is_sub_item = true
				if(this.$route.params.info_id != 'add'){
					this.setIsSubItemInfoIds(this.$route.params.info_id)
				}

				this._complete()
			},
			//初始化第二段经历的表单
			async initSubItemFormData(){
				let formData = {
					city:"",
					city_id:"",
					company: this.formData.company,
					company_id: this.formData.company_id,
					company_token: this.formData.company_token,
					dept:"",
					description:"",
					end_at:"",
					hidden:false,
					is_sub_item: true,
					kind:null,
					mentor_id:null,
					position:null,
					present:null,
					qrcode:"",
					start_at:"",
					title:"",
					title_id: "",
					updated_at:"",
					word_count:0
				}
				this.changeCurrentInfo(formData)
				this.formData = JSON.parse(JSON.stringify(formData))
				this.is_now_sub = true
				this.showToast('再写一段同公司经历', 1500);
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/cv/module';
	.add-exp-btn{
		width: 327px;
		height: 44px;
		background: #F9F9F9;
		border-radius: 22px;
		margin: 20px auto;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		font-weight: 400;
		color: #BCBCBC;
		border: 1px solid transparent;
		i{
			margin-right: 6px;
		}
		&.add-exp-btn-active{
			color: #4183FF;
			border: 1px dotted #669BFF;
			background: #Fff;
		}
	}
</style>
